export class StaffDetails {
    name! : string;
    serviceCharge! : string;
    clientPhoneNumber! : string;
}